import { useState } from 'react';
import * as constants from '../constants/CONSTANT';
const authApi = {
    async login(email, password) {
        //////('constants.API_BASE_URL', process.env.REACT_APP_API_BASE_URL)
        let response = await fetch(constants.API_BASE_URL + "/api/auth/login", {
            method: "POST",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                email: email,
                password: password,
            }),
        });

        const result = await response.json();
        if (result.success) {
            localStorage.setItem("token", result.authToken);

        }
        return result;
    },

    async fetchMyImage() {
        //////("calling my image ");
        const token = localStorage.getItem("token");
        let response = await fetch(
          constants.API_BASE_URL + "/api/auth/myimage",
          {
            method: "GET",
            //mode: "cors",
    
            headers: {
              "Authorization": token
            }
          }
        );
        //////('response:', response);
        if(response.status === 200){
          const fileBody = await response.blob();
          return fileBody;
        }else{
          return null;
        }
        
      },

      async fetchUserImage(userid) {
        //////("calling my image ");
        const token = localStorage.getItem("token");
        let response = await fetch(
          constants.API_BASE_URL + "/api/auth/userimage/" + userid,
          {
            method: "GET",
            //mode: "cors",
    
            headers: {
              "Authorization": token
            }
          }
        );
        //////('response:', response);
        const fileBody = await response.blob();
        return fileBody;
      },

    logout() {
        localStorage.removeItem("token");
        window.location.href = '/login';
    },

    async bs() {
        //////("sssss");
        return "yes";
    },

}

export default authApi
